<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else id="dashboard-doughnut-chart" class="py-2 pr-2 h-100">
    <div class="quiz-dashborad-wrp pl-3 p-relative">
      <div>
        <div class="d-flex justify-content-between">
          <div class="card-content-title-wrp">
            <div class="content-name">
              {{
                renderData.jsonOverride.Left_Title
                  ? renderData.jsonOverride.Left_Title
                  : config.config.left_title
              }}
            </div>
            <div
              class="content-value"
              v-if="
                renderData.jsonOverride.Button_Left_Title ||
                config.config.button_left_title
              "
            >
              <span>
                {{
                  renderData.jsonOverride.Button_Left_Title
                    ? renderData.jsonOverride.Button_Left_Title
                    : config.config.button_left_title
                }}</span
              >
              <span> คำตอบ</span>
            </div>
          </div>
          <div
            class="content-type d-flex justify-content-end"
            v-if="
              renderData.jsonOverride.Right_Title || config.config.right_title
            "
          >
            <div class="d-flex justify-content-between content-type-wrp">
              <div
                :class="
                  layoutData.module_name == 'SurveyDashboard'
                    ? 'border-type'
                    : ''
                "
              >
                Type :
              </div>
              <div class="d-flex ml-2">
                <div class="mr-1 icon-type-svg">
                  <component
                    :is="
                      resovleIcon(
                        renderData.jsonOverride.Right_Title
                          ? renderData.jsonOverride.Right_Title
                          : config.config.right_title
                      )
                    "
                    class="mr-2"
                  />
                </div>
                <div>
                  {{
                    renderData.jsonOverride.Right_Title
                      ? renderData.jsonOverride.Right_Title
                      : config.config.right_title
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col>
            <div
              class="content-title"
              v-if="layoutData.module_name == 'QuizDashboard'"
            >
              จำนวนลูกค้าทั้งหมด
            </div>
            <div class="d-flex justify-content-center align-item-center">
              <div v-if="renderData.data.length > 0" class="w-80">
                <v-chart
                  ref="chartBar"
                  class="chart-customer"
                  :option="option"
                  autoresize
                />
              </div>

              <div class="legend-wrp mb-2 pr-2">
                <div v-for="item in renderData.legend" :key="item.title">
                  <b-row>
                    <b-col>
                      <div class="d-flex align-items-center">
                        <div
                          class="legend-radius-color"
                          :style="{ backgroundColor: item.color }"
                        />
                        <div class="legend-title">
                          {{ item.title }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";

import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import MultipleChoiceSvg from "@/@core/components/svg/survey/MultipleChoice.vue";
import TextAreaSvg from "@/@core/components/svg/survey/TextArea.vue";
import DateSvg from "@/@core/components/svg/survey/Date.vue";
import DropdownSvg from "@/@core/components/svg/survey/Dropdown.vue";

import quizListModel from "@/models/survey-quiz/quiz-list";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TooltipComponent,
  TitleComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default {
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  components: {
    VChart,
    SingleChoiceSvg,
    MultipleChoiceSvg,
    TextAreaSvg,
    DateSvg,
    DropdownSvg,
  },
  setup(props) {
    const { fetchQueryDataDashboard } = quizListModel();

    const { fetchQueryDataDashboard: fetchQueryDataSurveyDashboard } =
      surveyModel();

    const { openDefaultErrorModal } = useValidationModal();

    const loading = reactive({
      Data: false,
    });

    const formData = reactive({
      groupId: "",
      moduleName: "",
    });

    const palette = reactive({
      QuizDashboard: ["#67AD5B", "#C6C6C6"],
      SurveyDashboard: [
        "#FD6383",
        "#FECC55",
        "#4CBFBE",
        "#35A3EB",
        "#9277FF",
        "#D4D4D4",
      ],
    });

    const MODULENAME = reactive({
      QUIZ: "QuizDashboard",
      SURVEY: "SurveyDashboard",
    });

    const resolveChartModule = (moduleName, GroupId) => {
      switch (moduleName) {
        case MODULENAME.QUIZ:
          fetchDashboradDetail(GroupId);
          return;
        case MODULENAME.SURVEY:
          fetchDashboradSurveyDetail(GroupId);
          return;
      }
    };

    const option = reactive({
      color: palette[props.layoutData.module_name], // Global palette chart
      tooltip: {
        trigger: "item",
        position: "left",
        formatter: "<div class='text-center'>{c} <br>({d}%)</div>", // a = name , b = data name , c = value , d= %,
        backgroundColor: "rgba(51, 51, 51,0.8)",
        // borderWidth: "0.8",
        borderColor: "rgba(0, 0, 0, 0)",
        textStyle: {
          color: "#fff",
        },
      },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: ["30%", "65%"],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            scaleSize: 15, // size ตอน  hover
          },

          labelLine: {
            show: false,
          },
          data: [],
        },
      ],
    });

    const renderData = reactive({
      data: [],
      legend: [],
      jsonOverride: {},
    });

    const fetchDashboradDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Quiz_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataDashboard)
        .then((response) => {
          renderData.data = response.data.list;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          response.data.list.map((o) => {
            renderData.legend.push({
              value: o.value,
              title: o.name,
              color: o.name == "ถูก" ? "#67AD5B" : "#C6C6C6",
            });
          });

          option.series[0].data = renderData.data;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resolveColor = (index) => {
      switch (index) {
        case 0:
          return "#FD6383";
        case 1:
          return "#FECC55";
        case 2:
          return "#4CBFBE";
        case 3:
          return "#35A3EB";
        case 4:
          return "#9277FF";
        case 5:
          return "#D4D4D4";
      }
    };

    const fetchDashboradSurveyDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Survey_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataSurveyDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataSurveyDashboard)
        .then((response) => {
          renderData.data = response.data.list;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          response.data.list.map((o, index) => {
            renderData.legend.push({
              value: o.value,
              title: o.name,
              color: resolveColor(index),
            });
          });

          option.series[0].data = renderData.data;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resovleIcon = (iconName) => {
      switch (iconName) {
        case "Single Choice":
          return "SingleChoiceSvg";
        case "Multiple Choice":
          return "MultipleChoiceSvg";
        case "Dropdown":
          return "DropdownSvg";
        case "Date":
          return "DateSvg";
        case "Text Area":
          return "TextAreaSvg";
      }
    };

    onBeforeMount(() => {
      formData.groupId = parseInt(router.currentRoute.params.ref);
      formData.moduleName = props.layoutData.module_name;

      resolveChartModule(formData.moduleName, formData.groupId);
    });

    return { option, renderData, loading, resovleIcon };
  },
};
</script>

<style >
#dashboard-doughnut-chart .icon-type-svg > svg {
  fill: #a2a2a2 !important;
  stroke: #a2a2a2 !important;
  width: 15px !important;
  height: 15px !important;
  margin-bottom: 1px;
}

#dashboard-doughnut-chart g#Rectangle_11537 {
  stroke: #a2a2a2 !important;
}
</style>

<style scoped>
#dashboard-doughnut-chart .chart-customer {
  width: 100%;
  height: 300px;
}

#dashboard-doughnut-chart .card-content-title-wrp {
  min-height: 70px;
}

#dashboard-doughnut-chart .content-name {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

#dashboard-doughnut-chart .content-value {
  font-size: 18px;
  padding-left: 16px;
  color: #707070;
}

#dashboard-doughnut-chart .content-title {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  padding-left: 16px;
}

#dashboard-doughnut-chart .content-type {
  font-size: 18px;
  color: #707070;
}

#dashboard-doughnut-chart .content-type-wrp {
  width: 163px;
}

#dashboard-doughnut-chart .legend-wrp {
  width: 20%;
  /* width: 200px; */

  /* position: absolute;
  bottom: 50%;
  right: 0;
  text-align: right;
  height: 100%;
  top: 0%;
  display: flex;
  flex-direction: column;
  justify-content: center; */
}

#dashboard-doughnut-chart .legend-radius-color {
  margin-right: 10px;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}

#dashboard-doughnut-chart .legend-title {
  font-size: 18px;
  color: #000;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* width: 155px; */
  width: 100px;
}

#dashboard-doughnut-chart .border-type {
  border-left: 1.5px solid #a2a2a2;
  height: 30px;
  padding-left: 10px;
}
</style>